"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendValidationCode = sendValidationCode;
var _view = require("../../types/view");
var _phoneAuth = require("../../types/phoneAuth");
var _requestStatus = require("../../types/requestStatus");
var _action_types = require("../../constants/action_types");
var _view2 = require("../view");
var _sendValidationCode = require("../../api/sendValidationCode");
var _sendCode = require("../../api/sendCode");
function sendValidationCode() {
  return async (dispatch, _getState, context) => {
    dispatch({
      status: _requestStatus.ERequestStatus.Loading,
      type: _action_types.PHONE_AUTH_SEND_VALIDATION_CODE_TYPE
    });

    // сбрасываем ошибки авторизации с помощью смс кода
    dispatch({
      status: _phoneAuth.ERegisterOrAuthStatus.Initial,
      type: _action_types.PHONE_AUTH_REGISTER_OR_AUTHORIZE_TYPE
    });
    const {
      view: {
        active: activeView
      },
      phoneAuth: {
        phone
      }
    } = _getState();
    try {
      const res = await (0, _sendValidationCode.sendValidationCode)(context.httpApi, phone);
      if (res.statusCode === 200) {
        dispatch({
          status: _requestStatus.ERequestStatus.Succeed,
          type: _action_types.PHONE_AUTH_SEND_VALIDATION_CODE_TYPE,
          senderType: _sendCode.ESenderType.Sms,
          secondsToRetry: res.response.secondsToRetry || 60,
          timeStamp: new Date().getTime()
        });
        if (activeView !== _view.EActiveView.PhoneAuthValidateSms) {
          dispatch((0, _view2.changeView)(_view.EActiveView.PhoneAuthValidateSms));
        }
      } else {
        dispatch({
          status: _requestStatus.ERequestStatus.Failed,
          type: _action_types.PHONE_AUTH_SEND_VALIDATION_CODE_TYPE,
          error: res.response.message
        });
      }
    } catch (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.sendValidationCode'
      });
      dispatch({
        status: _requestStatus.ERequestStatus.Failed,
        type: _action_types.PHONE_AUTH_SEND_VALIDATION_CODE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    }
  };
}